export const OfficeSurveyState = {
	url: '/settings-survey',
	template: '<office-survey-page></office-survey-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeSurveyPageMod" */
			'@Containers/office-survey-page/office-survey-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
